import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function ErrorStateV2({
  message,
  action,
  className,
}: {
  message: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        "v2-motion-state-fade rounded-[var(--v2-radius-md)] border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700",
        className
      )}
    >
      <p>{message}</p>
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
